<template>
    <div class="card-modern">
    
        <!-- HEADER -->
        <div class="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-3">
            <div>
                <h3 class="card-title-modern mb-1">Master Spesifikasi Perangkat</h3>
                <small class="card-desc-modern mb-0">Daftar spesifikasi perangkat yang digunakan pada aset IT perusahaan.</small>
            </div>
    
        </div>
        <div class="d-flex align-items-center justify-content-end gap-2 mb-3 flex-wrap">
            <div style="position: relative; width: 170px;">
                <i class="bi bi-search text-muted"
                    style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 1;"></i>
                <input v-model="filters.search" class="form-control" placeholder="Cari"
                    style="padding-left: 32px; border-radius: 8px;" @input="getData" />
            </div>
            <select v-model="filters.device_type_id" class="form-select" style="width: 170px;" @change="getData">
                <option value="">Semua Jenis Perangkat</option>
                <option v-for="dt in deviceTypeList" :key="dt.device_type_id" :value="dt.device_type_id">
                    {{ dt.device_type_name }}
                </option>
            </select>
            <select v-model="filters.status" class="form-select" style="width: 150px;" @change="getData">
                <option value="">Semua Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
            </select>
            <button class="button-modern text-nowrap" @click="openModal">
                <i class="bi bi-plus-lg me-1"></i>Add Spesifikasi
            </button>
        </div>
        <!-- TABLE -->
        <div class="modern-table-wrapper">
            <table class="table-modern">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Jenis Perangkat</th>
                        <th>Spesifikasi</th>
                        <th class="text-center">Status</th>
                        <th class="text-center">Aksi</th>
                    </tr>
                </thead>
                <tbody>
    
                    <tr v-if="loading">
                        <td colspan="5" class="text-center py-4">
                            <div class="spinner-border spinner-border-sm me-2"></div>
                            Memuat data...
                        </td>
                    </tr>
    
                    <tr v-else-if="items.length === 0">
                        <td colspan="5" class="text-center py-4 text-muted">
                            Tidak ada data spesifikasi perangkat
                        </td>
                    </tr>
    
                    <tr v-else v-for="(item, index) in items" :key="item.id">
                        <td>{{ (page - 1) * perPage + index + 1 }}</td>
                        <td><span class="fw">{{ item.device_type_name || '-' }}</span></td>
                        <td><span class="fw">{{ item.specification_name || '-' }}</span></td>
                        <td class="text-center">
                            <span class="badge-modern" :class="item.status == 1 ? 'badge-success' : 'badge-danger'">
                                {{ item.status == 1 ? 'Aktif' : 'Nonaktif' }}
                            </span>
                        </td>
                        <td class="text-center">
                            <button class="btn btn-sm bg-light border text-dark me-1" @click="openEdit(item)">
                                <i class="bi bi-pencil me-1 text-warning"></i>Edit
                            </button>
                            <button class="btn btn-sm" :class="item.status == 1 ? 'bg-danger-subtle border border-danger-subtle text-danger-emphasis' 
                                        : 'bg-success-subtle border border-success-subtle text-success-emphasis'"
                                @click="toggleStatus(item)" :title="item.status == 1 ? 'Nonaktifkan' : 'Aktifkan'">
                                <i class="bi" :class="item.status == 1 ? 'bi-slash-circle' : 'bi-check-circle'"></i>
                                {{ item.status == 1 ? ' Nonaktifkan' : ' Aktifkan' }}
                            </button>
                        </td>
                    </tr>
    
                </tbody>
            </table>
        </div>
    
        <!-- PAGINATION -->
        <div class="d-flex justify-content-between align-items-center mt-3">
            <small class="text-muted">
                Menampilkan {{ (page - 1) * perPage + 1 }} - {{ Math.min(page * perPage, total) }} dari {{ total }} data
            </small>
            <div class="d-flex align-items-center gap-2">
                <small class="text-muted">Rows per page</small>
                <select v-model.number="perPage" class="form-select form-select-sm" style="width: auto;"
                    @change="changePerPage">
                    <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
                </select>
                <nav>
                    <ul class="pagination pagination-sm mb-0">
                        <li class="page-item" :class="{ disabled: page === 1 }">
                            <button class="page-link" @click="changePage(page - 1)">&#8249;</button>
                        </li>
                        <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
                            :class="{ active: p === page, disabled: p === '...' }">
                            <button class="page-link" @click="p !== '...' && changePage(p)">{{ p }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: page === totalPages }">
                            <button class="page-link" @click="changePage(page + 1)">&#8250;</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    
        <!-- MODAL ADD / EDIT -->
        <Teleport to="body">
            <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.45);"
                @click.self="closeModal">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
    
                        <div class="modal-header">
                            <h5 class="modal-title">
                                {{ isEdit ? 'Edit Spesifikasi Perangkat' : 'Tambah Spesifikasi Perangkat' }}
                            </h5>
                            <button type="button" class="btn-close" @click="closeModal"></button>
                        </div>
    
                        <div class="modal-body">
    
                            <div v-if="formError" class="alert alert-danger py-2 small mb-3">
                                {{ formError }}
                            </div>
    
                            <!-- Jenis Perangkat -->
                            <div class="mb-3">
                                <label class="form-label">
                                    Jenis Perangkat <span class="text-danger">*</span>
                                </label>
                                <Multiselect v-model="form.device_type_id" :options="deviceTypeList"
                                    valueProp="device_type_id" label="device_type_name" placeholder="Pilih Jenis Perangkat"
                                    :searchable="true" :can-clear="true" />
                                <div v-if="errors.device_type_id" class="text-danger small mt-1">
                                    {{ errors.device_type_id }}
                                </div>
                            </div>
    
                            <!-- Spesifikasi (multi-select, hanya bisa pilih banyak saat mode Tambah) -->
                            <div class="mb-3">
                                <label class="form-label">
                                    Spesifikasi <span class="text-danger">*</span>
                                    <small v-if="!isEdit" class="text-muted">(bisa pilih lebih dari satu)</small>
                                </label>
                                <Multiselect v-model="form.specification_id" :options="specificationList"
                                    valueProp="specification_id" label="specification_name"
                                    :mode="isEdit ? 'single' : 'tags'" :searchable="true" :close-on-select="isEdit"
                                    placeholder="Pilih satu atau lebih spesifikasi..." />
                                <div v-if="errors.specification_id" class="text-danger small mt-1">
                                    {{ errors.specification_id }}
                                </div>
                            </div>
    
                            <!-- Status -->
                            <div class="mb-3">
                                <label class="form-label">Status</label>
                                <select v-model.number="form.status" class="form-select">
                                    <option :value="1">Active</option>
                                    <option :value="0">Inactive</option>
                                </select>
                            </div>
    
                        </div>
    
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="closeModal" :disabled="saving">
                                Batal
                            </button>
                            <button type="button" class="btn btn-primary" @click="saveForm" :disabled="saving">
                                <span v-if="saving">
                                    <span class="spinner-border spinner-border-sm me-1"></span>
                                    Menyimpan...
                                </span>
                                <span v-else>Simpan</span>
                            </button>
                        </div>
    
                    </div>
                </div>
            </div>
        </Teleport>
    
        <!-- TOAST NOTIFICATION -->
        <div v-if="toast.show" :class="['alert', 'alert-' + toast.type, 'position-fixed']"
            style="top: 24px; right: 24px; z-index: 9999; min-width: 260px; box-shadow: 0 4px 12px rgba(0,0,0,0.15);"
            role="alert">
            {{ toast.message }}
        </div>
    
    </div>
</template>

<script>
import DeviceSpecificationView from "./DeviceSpecificationView";
export default DeviceSpecificationView;
</script>